import { EnumBase } from 'hay-core-react';
// Reaproveitado tambem por PesquisaEnvio.canal e PesquisaResposta.tipo indiretamente onde fizer
// sentido (os valores sao os mesmos namespace main.pesquisa.tipoenvio.*, ver backend).
class PesquisaTipoEnvioEnum extends EnumBase {
    constructor() {
        super([
            'main.pesquisa.tipoenvio.email',
            'main.pesquisa.tipoenvio.sms',
            // Desabilitado no dropdown - envio via WhatsApp ainda nao esta implementado (ver
            // PesquisaEnvio.dispatch no backend, que so loga um aviso e nao despacha nada pra esse
            // canal). Mesmo padrao de PlanoTipoPlanoEnum.js (opcao existe/documentada, mas
            // desabilitada pra selecao ate a integracao existir).
            { chave: 'main.pesquisa.tipoenvio.whatsapp', desabilitado: true },
        ]);
    }
}

const instance = new PesquisaTipoEnvioEnum();
export default instance;
